import isFunction from 'lodash/isFunction';
import {createEventHandler} from 'recompose';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/withLatestFrom';
import {requestToButtonState} from '../../../core-utilities/redux-request/utils';
import {buildModel$} from './utils';


/**
 * @param {Object} config
 * @param {ReduxRequest} config.reduxRequest
 * @param {Function} config.getModalState
 * @param {Function(state$: Observable<Object>>, dispatch: Function, props$: Observable<Object>): Function} config.buildOnSave
 */
export const UpdateFormModalContainerHOC = (config) => (state$, dispatch) => (props$) => {
  const {
    reduxRequest,
    getModalState,
    buildOnSave,
  } = config;

  /** @type {ReduxRequestActions} */
  const actions = reduxRequest.actions;

  /** @type {ReduxRequestOptions} */
  const requestOptions = reduxRequest.options;

  const {
    model$,
  } = buildModel$({
    state$,
    getModalState,
  });

  const onSave = isFunction(buildOnSave)
    ? buildOnSave(state$, dispatch, props$, actions, model$)
    : defaultOnSave(state$, dispatch, props$, actions, model$);

  const mode$ = state$
    .map(requestOptions.getState)
    .map(requestToButtonState)
    .distinctUntilChanged();

  return props$
    .combineLatest(
      mode$,
      model$,
      (props, mode, model) => ({
        ...props,
        mode,
        model,
        onSave,
      }));
};

function defaultOnSave(state$, dispatch, props$, actions, model$) {
  const {
    handler: onSave,
    stream: save$,
  } = createEventHandler();

  save$
    .withLatestFrom(model$)
    .takeUntil(props$.last())
    .subscribe(([body, model]) => {
      const request = {
        body,
        data: model,
      };
      dispatch(actions.sendRequest(request));
    });

  return onSave;
}



// WEBPACK FOOTER //
// ./src/js/components/modals/FormModal/UpdateFormModalContainer.js